import { Component } from '@angular/core';

@Component({
  selector: 'ava-page-header',
  templateUrl: './page-logo-header.component.html',
  standalone: true,
})
export class PageLogoHeaderComponent {}
